import { render, staticRenderFns } from "./BlockElement.vue?vue&type=template&id=4a5067d0&scoped=true"
import script from "./BlockElement.vue?vue&type=script&lang=js"
export * from "./BlockElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5067d0",
  null
  
)

export default component.exports